import { IFELHASZNALO_DISP, IFELHASZNALO_NOTIFICATION, KONYVELO_ROUTES } from '@coimbra-its/api.konyvelo';
import { produce } from 'immer';
import { create } from 'zustand';


export interface IAuthState {
	sessionId: string | undefined,
	user: IFELHASZNALO_DISP | undefined,
	showSignOut: boolean;
}

export type TStartupResponse = typeof KONYVELO_ROUTES.startupPost.forResType;

export type IAuthSlice = IAuthState & {
	signedIn: (sessionId: string, user: IFELHASZNALO_DISP) => void;
	startupReady: (data: TStartupResponse) => void;
	signedOut: () => void;
	setShowSignOut: (v: boolean) => void;
	deviceId: string;
	notificationSubscriptions : IFELHASZNALO_NOTIFICATION[];
	setNotificationSubscriptions : (v : IFELHASZNALO_NOTIFICATION[]) => void;
	updateAvailable : boolean;
	setUpdateAvailable : (v: boolean) => void;
}

let initDeviceId = window.localStorage.getItem('websys-device-id');
if (!initDeviceId) {
	initDeviceId = '' + (Math.floor(Math.random() * 900000) + 100000);
	window.localStorage.setItem('websys-device-id', initDeviceId);
}


export const useWSysAuthSlice = create<IAuthSlice>()(


	(set, get) => ({
		sessionId: localStorage.getItem('SESSION_ID') || undefined,
		user: undefined,
		showSignOut: false,
		notificationSubscriptions:[],

		// --- after get sessionId in url query ----

		signedIn: (sessionId: string, user: IFELHASZNALO_DISP) => set(produce((state: IAuthSlice) => {
			state.user = user;
			window.localStorage.setItem('SESSION_ID', sessionId);
		})),

		startupReady: (data: TStartupResponse) => set(produce((state: IAuthSlice) => {
			state.user = data.user;
			state.notificationSubscriptions = data.notification_subscriptions || [];
		})),

		signedOut: () => set(produce((state: IAuthSlice) => {
			state.user = undefined;
			state.sessionId = undefined;
			window.localStorage.removeItem('SESSION_ID');
		})),

		setShowSignOut: (v: boolean) => set(produce((state: IAuthSlice) => {
			state.showSignOut = v;
		})),

		setNotificationSubscriptions: (v: IFELHASZNALO_NOTIFICATION[]) => set(produce((state: IAuthSlice) => {
			state.notificationSubscriptions = v;
		})),		

		deviceId : initDeviceId,

		updateAvailable : false,
		setUpdateAvailable: (v: boolean) => set(produce((state: IAuthSlice) => {
			state.updateAvailable = v;
		})),
	}));

export function useSessionId() {
	//const { sessionId } = useWSysAuthSlice((state: IAuthSlice) => ({ sessionId: state.sessionId }));
	return window.localStorage.getItem('SESSION_ID');
}





